import React, { lazy, PropsWithChildren, useContext } from 'react'
import { CrowdSurfConfig, CrowdSurfConfigContext } from './appconfig'
import { getCookie } from './cookie_helper'

const CSRF_DATA_ELEMENT_NAME = 'd3V0YW5n' // This identifier is static and agreed upon by A20M. https://issues.amazon.com/issues/A20M-Product-168
const SESSION_ID_COOKIE = 'session-id'

const AAPNApolloProvider = lazy(() => import('@amzn/aapn-front-end-apollo-client').then(module => ({ default: module.AAPNApolloProvider })))
const getCSRFTokenData = (): string => {
  const token = document.getElementsByName(CSRF_DATA_ELEMENT_NAME)[0] as HTMLInputElement
  return token ? token.value : ''
}

export type CrowdSurfApolloProviderProps = PropsWithChildren<{
  appConfigApiKey?: 'apiEndpoint' | 'leadsApiEndpoint'
}>

const A20M_HOST_NAMES: Set<string> = new Set(['advertising.integ.amazon.com', 'advertising-preprod.amazon.com', 'advertising.amazon.com'])

export const isA20MEndPoint = (hostname: string): boolean => A20M_HOST_NAMES.has(hostname)

export const CrowdSurfApolloProvider: React.FunctionComponent<CrowdSurfApolloProviderProps> = (props: CrowdSurfApolloProviderProps) => {
  const appConfig = useContext<CrowdSurfConfig>(CrowdSurfConfigContext)
  const hostname = window?.location?.hostname
  const apiConfigKey = props.appConfigApiKey || 'apiEndpoint'
  const endpoint: string =
    !isA20MEndPoint(hostname) && !!appConfig.midwayAuthApiEndpoint && !props.appConfigApiKey ? appConfig.midwayAuthApiEndpoint : appConfig[apiConfigKey]

  const headers: { [key: string]: string } = {
    'Amazon-Advertising-API-CSRF-Data': getCSRFTokenData(),
    'Amazon-Advertising-API-Session-Id': getCookie(SESSION_ID_COOKIE),
  }

  return (
    <AAPNApolloProvider apiEndpoint={endpoint} headerOptions={headers}>
      {props.children}
    </AAPNApolloProvider>
  )
}
